export default "__VITE_ASSET__DWpr$8hV__"